import script from "./ListInvoicePur.vue?vue&type=script&setup=true&lang=js"
export * from "./ListInvoicePur.vue?vue&type=script&setup=true&lang=js"

import "./ListInvoicePur.vue?vue&type=style&index=0&id=315b8c43&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-315b8c43"]])

export default __exports__